const TOOLS = [
  { name: "PREMIERE PRO", logo: "https://upload.wikimedia.org/wikipedia/commons/4/40/Adobe_Premiere_Pro_CC_icon.svg" },
  { name: "AFTER EFFECTS", logo: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Adobe_After_Effects_CC_icon.svg" },
  { name: "PHOTOSHOP", logo: "https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg" },
  { name: "ILLUSTRATOR", logo: "https://upload.wikimedia.org/wikipedia/commons/f/fb/Adobe_Illustrator_CC_icon.svg" },
  { name: "AUDITION", logo: "https://upload.wikimedia.org/wikipedia/commons/0/0e/Adobe_Audition_CC_icon_%282020%29.svg" },
  { name: "DAVINCI RESOLVE", logo: "https://upload.wikimedia.org/wikipedia/commons/4/4d/DaVinci_Resolve_Studio.png" },
  { name: "AI EDITING TOOLS" },
  { name: "STORYTELLING" },
  { name: "SOUND DESIGN" },
  { name: "COLOR THEORY" },
  { name: "CLIENT COMMUNICATION" },
  { name: "PERSONAL BRANDING" },
];

export default function ToolsStrip() {
  const row = [...TOOLS, ...TOOLS];
  return (
    <div className="bg-lima-blue overflow-hidden py-4 select-none border-y border-black" data-testid="tools-strip">
      <div className="flex items-center px-5 md:px-10 mb-3">
        <span className="font-mono2 text-[11px] tracking-[0.3em] text-white/70">YOUR DAILY TOOLKIT —</span>
      </div>
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((t, i) => (
              <span key={i} className="flex items-center gap-3 font-display font-bold text-lg md:text-xl tracking-tight text-white">
                <span className="flex items-center gap-3 px-6 md:px-8">
                  {t.logo && <img src={t.logo} alt="" className="w-6 h-6 md:w-7 md:h-7 rounded-[4px]" loading="lazy" />}
                  {t.name}
                </span>
                <span className="text-white/50 text-xs" aria-hidden="true">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
